import React, { useCallback, useEffect, useState, useRef } from 'react';
import Table from 'react-bootstrap/Table';
import { motion } from "framer-motion";

import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

import { searchIcon } from "../../../../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { getEndPointList } from "../../../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../../../apiEndpoints";

const PresentIn = ({selectedTechnology, domainId, scanId, currentPageType="sslRecord"}) => {

    const EndpointListResponse = useSelector((state) => state?.scanInfo.endPointsList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null)

    const dispatch = useDispatch();

    const [endPointList, setEndPointList] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    
    const [endpointSearch, setEndPointSearch] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(endpointSearch)
    }

    const fetchEndPointsList = useCallback(()=>{
        const queryParams = `&query=${searchQuery}`
        setIsLoading(true)
        if(currentPageType === "sslRecord") {
            const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.sslCertificate.endPoints()}&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedTechnology?.domain}&scan_id=${selectedTechnology?.scan_id}&result_id=${selectedTechnology?.id}`
            const url = `${baseUrl}${queryParams}`
            dispatch(getEndPointList(url))
        } else {
            const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.assetDiscovery.technology.endPoints()}&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedTechnology?.domain}&scan_id=${selectedTechnology?.scan_id}&result_id=${selectedTechnology?.id}`
            const url = `${baseUrl}${queryParams}`
            dispatch(getEndPointList(url))
        }        
    },[dispatch, selectedTechnology, currentPageSize, currentPage, currentPageType, searchQuery])

    useEffect(()=>{
        if(selectedTechnology || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {            
            fetchEndPointsList();
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId
        }
    },[domainId, scanId, fetchEndPointsList, selectedTechnology]);

    useEffect(()=>{
        if(EndpointListResponse !== null) {
            setIsLoading(false)
            setEndPointList(EndpointListResponse)
        }
    },[EndpointListResponse])

    return (
        <div className="mt-3">               
            <div className="record-container-content p-2">
                <div className="search-header-container d-flex align-items-center gap-3 mt-3 mb-4">
                    <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                        <div className="search-container position-relative">
                            <span className="position-absolute">{searchIcon()}</span>
                            <input type="text" 
                                placeholder="Search" 
                                value={endpointSearch} 
                                onChange={(e)=>{
                                    setEndPointSearch(e.target.value)
                                }}
                                onFocus={() => setIsSearchFocused(true)}
                                onBlur={() => setIsSearchFocused(false)}
                            />
                        </div>
                        <button className="search-btn" onClick={onSearch}>Search</button>
                    </div>
                </div>
                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={5} currentPage={"technology"} />
                    :
                    <Table>
                        <thead>
                            <tr>
                                <th>Domain</th>
                                <th>Host</th>
                                <th>Port</th>
                                {currentPageType === "technology" && <th>Version</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                endPointList !== "" && endPointList?.results?.length > 0 &&
                                endPointList.results.map((data, index) => {
                                    return (
                                        <motion.tr
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <td>
                                                {data?.domain}
                                            </td>
                                            <td>
                                                {data?.host}
                                            </td>
                                            <td>
                                                <p>{data?.port}</p>
                                            </td>
                                            {currentPageType === "technology" && <td>
                                                {data?.version != null ? data?.version : "-"}
                                            </td>}
                                        </motion.tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                }
                {
                    !isLoading && endPointList !== "" && endPointList?.results?.length === 0 && 
                    <NoDataFound noDataText={"No Record Found"}/>
                }
                {endPointList !== "" && endPointList?.results?.length > 0 && <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    pageSize={currentPageSize}
                    totalCount={endPointList?.meta?.total_results}
                    onPageChange={setCurrentPageandRecordSize}
                />}
            </div>            
        </div>
    )
}

export default PresentIn;